<template>
    <footer class="p-sm-4 bg-white mb-0 rounded">
        <div class="container py-4">
            <div class="row gy-4 gx-5">
                <div class="col-lg-4 col-md-6">
                    <h5 class="h3">{{G.projectName}}</h5>
                    <p class="small text-muted">{{G.footerDescription}}</p>
                </div>
                <div class="col-lg-2 col-md-6">
                    <h5 class="mb-3">Məlumat</h5>
                    <ul class="list-unstyled text-muted">
                        <li><a href="#">Ana səhifə</a></li>
                        <li><a href="#">Bioqrafiya</a></li>
                        <li><a href="#">Çıxışlar</a></li>
                        <li><a href="#">Əlaqə</a></li>
                    </ul>
                </div>
                <div class="col-lg-2 col-md-6">
                    <h5 class="mb-3">Fəaliyyət</h5>
                    <ul class="list-unstyled text-muted">
                        <li><a href="#">Müraciətlər</a></li>
                        <li><a href="#">Göndərdiyi sorğular</a></li>
                        <li><a href="#">Vətəndaş qəbulları</a></li>
                        <li><a href="#">Beynəlxalq fəaliyyət</a></li>
                    </ul>
                </div>
                <div class="col-lg-4 col-md-6">
                    <h5 class="mb-3">Xəbər bülleteni</h5>
                    <p class="small text-muted">Xəbər bülleteninə qoşulmaqla Siz daima yeniliklərdən xəbərdar olacaqsınız.</p>
                    <form action="#">
                        <div class="input-group mb-3">
                            <input class="form-control" type="text" placeholder="Sizin email ünvanınız" aria-label="..." aria-describedby="button-addon2">
                            <button class="btn btn-primary" id="button-addon2" type="button"><i class="fas fa-paper-plane"></i></button>
                        </div>
                    </form>
                </div>
            </div>


            <div class="row row-cols-1 row-cols-sm-2 mt-4 pt-3 border-1 border-top text-muted small">
                <div class="col">
                    <p v-html="G.footerPowered"></p>
                </div>
                <div class="col d-flex">
                    <ul class="list-unstyled d-flex ms-auto">
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-google"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer>
</template>


<script>
import { G } from '@/_common';

export default {
    name: 'FooTer',
    setup() {
        return { G };
    },
}
</script>


<style lang="scss">
</style>